import { Link } from '@/components/common/Link';
import { useState, useEffect, useRef } from "react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function NavMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [productsOpen, setProductsOpen] = useState(false);
  const productsRef = useRef<HTMLLIElement>(null);
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (productsRef.current && !productsRef.current.contains(e.target as Node)) {
        setProductsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  if (loading) return null;
  return <>
      <nav id="top-menu-nav" className="hidden md:flex items-center justify-center" style={{
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      color: "rgb(102, 102, 102)",
      fontFamily: '"Open Sans", Arial, sans-serif',
      textAlign: "center",
      animation: "none 0s ease 0s 1 normal none running"
    }}>
        <ul className="flex items-center justify-center gap-8">
          {menuItems.map((item, i) => {
          const hasChildren = item.children && item.children.length > 0;
          if (hasChildren) {
            return <li key={item.id} data-index={i} ref={productsRef} className={`has-dropdown${productsOpen ? " open" : ""}`} onMouseEnter={() => setProductsOpen(true)} onMouseLeave={() => setProductsOpen(false)}>
                  <Link to={item.href || "#"} className="dropdown-arrow">
                    {item.label}
                  </Link>
                  <div className="nav-dropdown">
                    {item.children?.map((child, ci) => <Link key={child.id} data-index={ci} to={child.href || "#"}>
                        {child.label}
                      </Link>)}
                  </div>
                </li>;
          }
          return <li key={item.id} data-index={i}>
                <Link to={item.href || "#"}>{item.label}</Link>
              </li>;
        })}
        </ul>
      </nav>

      <Sheet>
        <SheetTrigger asChild>
          <button className="ml-auto md:hidden flex flex-col justify-center items-center gap-1 p-2" aria-label="Open menu" style={{
          background: "none",
          border: "none",
          cursor: "pointer"
        }}>
            <span style={{
            display: "block",
            width: "22px",
            height: "2px",
            background: "#004654",
            borderRadius: "2px"
          }} />
            <span style={{
            display: "block",
            width: "22px",
            height: "2px",
            background: "#004654",
            borderRadius: "2px"
          }} />
            <span style={{
            display: "block",
            width: "22px",
            height: "2px",
            background: "#004654",
            borderRadius: "2px"
          }} />
          </button>
        </SheetTrigger>
        <SheetContent side="right" style={{
        width: "100%",
        padding: "32px 24px",
        backgroundColor: "#f5f5f5",
        color: "#333"
      }}>
          <nav style={{
          fontFamily: "'Open Sans', Arial, sans-serif",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "0.5rem"
        }}>
            {menuItems.map((item, i) => <div key={item.id} data-index={i} className="w-full flex flex-col">
                <Link to={item.href || "#"} className="mobile-nav-link w-full" style={{
              padding: "16px 24px",
              fontSize: "16px",
              display: "block",
              color: "#333",
              borderBottom: "1px solid #e0e0e0"
            }}>
                  {item.label}
                </Link>
                {item.children && item.children.length > 0 && <div className="flex flex-col ml-4">
                    {item.children.map((child, ci) => <Link key={child.id} data-index={ci} to={child.href || "#"} className="mobile-nav-link w-full" style={{
                padding: "12px 24px",
                fontSize: "14px",
                display: "block",
                opacity: 0.8
              }}>
                        {child.label}
                      </Link>)}
                  </div>}
              </div>)}
          </nav>
        </SheetContent>
      </Sheet>
    </>;
}
export default function Header() {
  return <MenuProvider menu_id="16" className="flex items-center h-24 px-6 bg-white shadow-sm">
      <div className="flex-shrink-0">
        <Link to="/">
          <WvcLogo className="h-12 w-auto" />
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center">
        <NavMenuContent />
      </div>
    </MenuProvider>;
}